import { render, staticRenderFns } from "./BusinessMemberHistory.vue?vue&type=template&id=0ef6be70"
import script from "./BusinessMemberHistory.vue?vue&type=script&lang=js"
export * from "./BusinessMemberHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports